var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import QRCode from "react-qr-code";
import { RemoteLoadedImage } from "./RemoteLoadedImage";
import { generateJoinEESocialCommunityLink, TrackedLinkSource, TrackedLinkFormat, } from "ee-utils";
export var JoinCommunityQRCode = function (_a) {
    var chargerOcppId = _a.chargerOcppId, XLogoUrl = _a.XLogoUrl, trackedLinkBaseUrl = _a.trackedLinkBaseUrl;
    var url = generateJoinEESocialCommunityLink({
        entityId: chargerOcppId,
        entityType: "chargerOcppId",
        source: TrackedLinkSource.CUI_INSTRUCTIONS_SCREEN,
        format: TrackedLinkFormat.QR,
        baseUrl: trackedLinkBaseUrl,
    });
    // QR code size is driven by general guidelines outlined here:
    // https://electricera.atlassian.net/wiki/spaces/SW/pages/1319108609/QR+Code+Guidelines
    //
    // In particular, we'll want to be at least 2.5 in (=175 pixels on a 70 PPI screen).
    // Our average URL will be 200 characters, so pick medium ECC at this size.
    var qrSizePixels = 175;
    var qrEcc = "M";
    return (_jsxs("div", __assign({ className: "grid h-fit w-fit grid-cols-1 items-center gap-4 p-2" }, { children: [_jsxs("label", __assign({ className: "font-L1 text-center text-black h-8" }, { children: ["Join the Electric Era Driver Club on", " ", _jsx(RemoteLoadedImage, { src: XLogoUrl, className: "inline h-4 mb-1" })] })), _jsx("div", __assign({ className: "flex flex-col items-center" }, { children: _jsx("div", __assign({ className: "rounded-lg bg-white p-2" }, { children: _jsx(QRCode, { value: url, size: qrSizePixels, level: qrEcc }) })) })), _jsx("label", __assign({ className: "font-B1 text-black/70 text-center" }, { children: "Stay up-to-date with latest news and station annoucements" }))] })));
};
